import ChangePasswordBlock, { ChangePasswordBlockProps } from './ChangePasswordBlock';
import withInteractor from './ChangePasswordBlock.interactor';
import withPresenter from './ChangePasswordBlock.presenter';
import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';

export type { ChangePasswordBlockProps };
export default withInteractor(withPresenter(withErrorHandler(ChangePasswordBlock)));
